import type {ResolvedReference} from '../../api/references.api';
export function ReferencePreview({item}:{item:ResolvedReference}) {
 if(!item.available || !item.fields?.length)return null;
 return <details className="reference-inline-preview"><summary>Détails de l’objet</summary><dl>{item.fields.map(field=><div key={field.label}><dt>{field.label}</dt><dd>{field.value}</dd></div>)}</dl></details>;
}
